import { render } from "./VTasks.vue?vue&type=template&id=2aadb394"
import script from "./VTasks.vue?vue&type=script&lang=js"
export * from "./VTasks.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__